/**
 * Virtual census — deterministic booked time for clinician-days outside the
 * real-data window. With the SQL seed covering demo day −7 … +28, the virtual
 * census only matters beyond the horizon; there are no story overrides any more
 * (Dana's weeks are read from the seed, not a fixture).
 */
import type { VirtualCensusState } from "@caredna-marlin/utils/homeHealthDemo/state";

export function buildVirtualCensus(seed: number): VirtualCensusState {
  return { seed, overrides: {} };
}
